import { render, staticRenderFns } from "./CallOutText.vue?vue&type=template&id=106b08b6&scoped=true"
import script from "./CallOutText.vue?vue&type=script&lang=js"
export * from "./CallOutText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106b08b6",
  null
  
)

export default component.exports